import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-emerald-400 transition-colors mb-8" data-testid="privacy-back-link">
          <ArrowLeft size={14} /> Back to home
        </Link>

        <article className="prose prose-invert prose-slate max-w-none
          prose-headings:text-foreground prose-headings:font-bold
          prose-h1:text-3xl sm:prose-h1:text-4xl prose-h1:mb-2
          prose-h2:text-xl prose-h2:mt-10 prose-h2:mb-4 prose-h2:border-b prose-h2:border-border prose-h2:pb-3
          prose-h3:text-lg prose-h3:mt-6 prose-h3:mb-3
          prose-p:text-muted-foreground prose-p:leading-relaxed
          prose-li:text-muted-foreground prose-li:leading-relaxed
          prose-strong:text-foreground
          prose-a:text-emerald-400 prose-a:no-underline hover:prose-a:text-emerald-300
          prose-hr:border-border">

          <h1 data-testid="privacy-title">Agent9 Privacy Policy</h1>
          <p className="text-sm text-muted-foreground !mt-1 !mb-8"><strong className="text-muted-foreground">Effective Date:</strong> March 18, 2026</p>
          <p>Agent9 ("we", "our", or "us") respects your privacy. This Privacy Policy explains how we collect, use, and protect your information.</p>

          <hr />

          <h2>1. Information We Collect</h2>
          <p>We may collect:</p>

          <h3>Account Information</h3>
          <ul>
            <li>Name, email, phone number</li>
            <li>Brokerage and business details</li>
          </ul>

          <h3>Communication Data</h3>
          <ul>
            <li>Call recordings</li>
            <li>Transcripts</li>
            <li>SMS and email messages</li>
            <li>AI-generated responses</li>
          </ul>

          <h3>Usage Data</h3>
          <ul>
            <li>Platform activity</li>
            <li>Feature usage</li>
            <li>Analytics data</li>
          </ul>

          <h2>2. How We Use Information</h2>
          <p>We use your data to:</p>
          <ul>
            <li>Provide and improve Agent9 services</li>
            <li>Process communications and automation</li>
            <li>Generate AI responses</li>
            <li>Analyze performance and usage</li>
            <li>Ensure compliance and security</li>
          </ul>

          <h2>3. AI Processing</h2>
          <p>Your data may be processed by AI systems to:</p>
          <ul>
            <li>Generate responses</li>
            <li>Summarize conversations</li>
            <li>Automate workflows</li>
          </ul>
          <p>We do not guarantee AI outputs are always accurate.</p>

          <h2>4. Data Sharing</h2>
          <p>We do not sell your personal data.</p>
          <p>We may share data with:</p>
          <ul>
            <li>Communication providers (telephony, SMS, email)</li>
            <li>Infrastructure providers (hosting, storage)</li>
            <li>AI service providers</li>
          </ul>

          <h2>5. Data Retention</h2>
          <p>We retain data as long as necessary to:</p>
          <ul>
            <li>Provide services</li>
            <li>Comply with legal obligations</li>
            <li>Resolve disputes</li>
          </ul>

          <h2>6. Security</h2>
          <p>We implement reasonable safeguards to protect your data, but no system is 100% secure.</p>

          <h2>7. User Responsibilities</h2>
          <p>You are responsible for:</p>
          <ul>
            <li>Obtaining consent before contacting leads</li>
            <li>Complying with applicable laws (TCPA, CAN-SPAM, etc.)</li>
          </ul>

          <h2>8. Your Rights</h2>
          <p>Depending on your location, you may have rights to:</p>
          <ul>
            <li>Access your data</li>
            <li>Request deletion</li>
            <li>Opt out of communications</li>
          </ul>

          <h2>9. Changes</h2>
          <p>We may update this Privacy Policy. Continued use means you accept updates.</p>

          <h2>10. Contact</h2>
          <p><a href="mailto:support@agent9.ai">support@agent9.ai</a></p>
        </article>
      </div>
    </div>
  );
}
